<template>
    <Link v-if="usedBanner.url" class="gmf-mini-banner" :href="usedBanner.url">
        <div class="gmf-mini-banner-img" :class="imageClasses">
            <div v-if="usedBanner.quantity > 1" class="gmf-mini-banner-quantity">
                {{ usedBanner.quantity }}
            </div>
            <img :src="usedBanner.imageUrl" />
        </div>
        <div class="gmf-mini-banner-content" v-if="bannerText" v-html="bannerText" />
        <div class="gmf-btn gmf-btn-primary" v-if="usedBanner.buttonText" :class="btnClasses">{{ usedBanner.buttonText }}</div>
    </Link>
    <a v-else class="gmf-mini-banner" @click="usedBanner.onClick" href="#">
        <div class="gmf-mini-banner-img" :class="imageClasses">
            <div v-if="usedBanner.quantity > 1" class="gmf-mini-banner-quantity">
                {{ usedBanner.quantity }}
            </div>
            <img :src="usedBanner.imageUrl" />
        </div>
        <div class="gmf-mini-banner-content" v-if="bannerText" v-html="bannerText" />
        <div class="gmf-btn gmf-btn-primary" v-if="usedBanner.buttonText" :class="btnClasses">{{ usedBanner.buttonText }}</div>
    </a>
</template>

<style>
.gmf-mini-banner {
    min-height: 100%;
    height: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: var(--gmf-p-3);
    /*overflow: hidden;*/
    border-radius: var(--gmf-rounding);
    position: relative;
    background: var(--gmf-social-banner-col-bg);
    cursor: pointer;

    text-decoration: none !important;
}
.gmf-mini-banner:has(> .gmf-mini-banner-img-loot-crate) {
    overflow: hidden;
    background: var(--gmf-col-white);
    height: 80px;
}

.gmf-mini-banner-img {
    flex-grow: 1;
    display: flex;
    height: 100%;
    align-items: flex-end;
    position: relative;
}

.gmf-mini-banner-img-full {
    position: absolute;
    inset: 0;
    width: 100%;
    margin-left: 4px;
    margin-right: 4px;
}

.gmf-mini-banner-img img {
    max-height: 120%;
    max-width: 100%;
    object-fit: contain;
}
.gmf-mini-banner-img-loot-crate {
    aspect-ratio: 1;
    max-height: 100%;
    padding: var(--gmf-p-4);
    flex-grow: 0;
    /*background: var(--gmf-social-banner-col-bg);*/
}
.gmf-mini-banner-img-loot-crate img {
    height: 200%;
    width: 200%;
    margin: -50%;
    max-width: unset !important;
    max-height: unset !important;
}

.gmf-mini-banner-content {
    flex-grow: 1;
}

.gmf-mini-banner .gmf-btn {
    margin-left: auto;
    margin-right: var(--gmf-p-5);
    white-space: nowrap;
    z-index: 1;
    position: relative;
}

.gmf-mini-banner-quantity {
    position: absolute;
    top: var(--gmf-p-3);
    right: var(--gmf-p-3);
    color: var(--gmf-col-white) !important;
    background-color: var(--gmf-col-black);
    border-radius: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
    height: 20px;
    width: 20px;
    text-align: center;
    font-size: var(--gmf-text-small-font-size) !important;
}
</style>

<script>
import state from '@/state';
import Link from '@/components/Link';
import openSocialModal from '@/widgets/SocialFeed/openSocialModal';
import md from '@/utils/md';

export default {
    components: {
        Link,
    },
    props: {
        banner: {
            type: Object,
            required: false,
        },
    },
    computed: {
        btnClasses () {
            return {
                'gmf-btn-sm': !!this.bannerText,
            };
        },
        imageClasses () {
            return {
                'gmf-mini-banner-img-full': !this.usedBanner.text,
                'gmf-mini-banner-img-loot-crate': this.usedBanner.imageType === 'lootCrate',
            };
        },
        bannerText () {
            if (!this.usedBanner.text) {
                return null;
            }
            return md(this.usedBanner.text);
        },
        usedBanner() {
            if (this.banner) {
                return this.banner;
            }
            const a = {
                imageUrl: state.merchantConfig?.widgets?.socialBanner?.image,
                buttonText: state.t('social_banner.button_text'),
                text: null,
                url: state.merchantConfig?.widgets?.urls?.socialFeed,
                onClick: openSocialModal,
            };
            return a;
        },
    },
};
</script>